module.exports = __webpack_public_path__ + "static/media/emma-john.2c13188a.png";